import { Tooltip } from '../tooltips/Tooltip'
import { useSafePush } from '../../hooks/useSafePush'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslation } from 'next-i18next'
import Box, { BoxProps } from '@mui/material/Box'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { getSearchFilterHref } from '@/helpers/filters'
import { SpriteIcon } from '@/assets/sprites/SpriteIcon'

interface SearchBoxProps extends BoxProps {
  searchString: string
}

export const SearchBox = ({ searchString, ...props }: SearchBoxProps): React.ReactElement => {
  const [search, setSearch] = React.useState<string>(searchString ?? '')
  const { asPath } = useRouter()
  const { safePush } = useSafePush()
  const { t } = useTranslation('subheader')

  const handleClick = (): void => {
    if (search != null) {
      safePush(getSearchFilterHref(search, asPath))
    }
  }

  return (
    <Box {...props}>
      <TextField
        type="search"
        size="small"
        value={search}
        onChange={(e): void => setSearch(e.target.value)}
        onKeyUp={(e): void => {
          if (e.key === 'Enter') {
            handleClick()
          }
        }}
        placeholder="Search..."
        sx={{
          backgroundColor: 'white',
          width: '220px',
          maxWidth: '300px'
        }}
        qa-attribute="searchInput"
        fullWidth
        variant="outlined"
        InputProps={{
          sx: { height: '40px' },
          endAdornment: (
            <Tooltip title={t('search')} describeChild={true}>
              <InputAdornment position="end" sx={{ p: 1 }} onClick={handleClick}>
                <SpriteIcon spriteId="search" width={13} height={13} sx={{ cursor: 'pointer' }} />
              </InputAdornment>
            </Tooltip>
          )
        }}
      />
    </Box>
  )
}
